export default __webpack_public_path__ + "assets/fonts/ClanPro-CompMedium.d1bb47180aa5dee764d278a8f27f3168.otf";